import { GuardedDeletionService } from 'projects/orchestrator/src/lib/services/guarded-deletion.service';
import { Component, inject } from '@angular/core';
import { PipelinePropertyService } from '../proxy/operational/controllers';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { PipelinePropertyProjectionPlanningOrchestratorService } from 'orchestrator';
import { PipelinePropertyCreateDto, PipelinePropertyUpdateDto, PipelinePropertyDto } from '../proxy/operational/dtos/pipeline-property';
import { GetPipelinePropertyProjectionListInputDto, PipelinePropertyProjectionDto, PipelinePropertyProjectionExcelDownloadDto } from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/pipeline-properties/models';
import { PIPELINEPROPERTY_CONFIG, PIPELINEPROPERTY_FIELDS } from './pipeline-property.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';

@Component({
  selector: 'app-pipeline-property',
    imports: [GenericForm, ZnHierarchicalViewComponent],
  providers: [ListService, PipelinePropertyService, ConfirmationService],
  templateUrl: './pipeline-property.html',
  styleUrl: './pipeline-property.scss',
})
export class PipelineProperty extends BaseHierarchicalCrudComponent<
  PipelinePropertyDto,
  PipelinePropertyCreateDto,
  PipelinePropertyUpdateDto,
  PipelinePropertyProjectionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  private readonly operationalService = inject(PipelinePropertyService);
  private readonly projectionOrchestratorService = inject(PipelinePropertyProjectionPlanningOrchestratorService);

  service = {
    create: (input: PipelinePropertyCreateDto) => this.operationalService.create(input),
    update: (id: number, input: PipelinePropertyUpdateDto) => this.operationalService.update(id, input),
    deleteByIds: ids => this.guardedDeletion.deleteByIds('pipeline-properties', ids),
    getList: (input: GetPipelinePropertyProjectionListInputDto) => this.projectionOrchestratorService.getList(input),
    getDownloadToken: () => this.projectionOrchestratorService.getDownloadToken(),
    getListAsExcelFile: (input: PipelinePropertyProjectionExcelDownloadDto) => this.projectionOrchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(this.projectionOrchestratorService, 'pipelinePropertyId'),
  };

  config = PIPELINEPROPERTY_CONFIG;
  fields = PIPELINEPROPERTY_FIELDS;

  protected prepareUpdateDto(data: any, selected: PipelinePropertyProjectionDto): PipelinePropertyUpdateDto {
    return {
      name: data.name,
      zoneId: data.zoneId,
      propertyTypeId: data.propertyTypeId,
      periodId: data.periodId,
      signatureReasonId: data.signatureReasonId,
      dinamaReasonId: data.dinamaReasonId,
      millLocationId: selected.millLocationId,
      distanceToMill: selected.distanceToMill,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PipelineProperty';
  }
}
